import { render, staticRenderFns } from "./CopyRoleDialog.vue?vue&type=template&id=a723c6a8&"
import script from "./CopyRoleDialog.vue?vue&type=script&lang=js&"
export * from "./CopyRoleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports